import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { name: "Home", link: "/" },
  { name: "Events", link: "/events" },
];

function NavigationBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (link) =>
    link === "/" ? location.pathname === "/" : location.pathname.startsWith(link);

  const close = () => { setMenuOpen(false); window.scrollTo(0, 0); };

  return (
    <nav className={`fixed top-0 z-50 w-full transition-all duration-300 ${
      scrolled ? "bg-white shadow-md" : "bg-white/85 backdrop-blur-md"
    }`}>
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-4">

        {/* Logo */}
        <Link to="/" onClick={close} className="flex items-center gap-2.5 shrink-0">
          <img
            src="/assets/img/logo/arsen2026-icon.png"
            alt=""
            className="h-8 w-8 object-contain"
          />
          <span className="font-extrabold text-base sm:text-lg tracking-wide text-arsen-quaternary-950">
            ARS<span className="text-arsen-primary">Σ</span>N UNAIR
          </span>
        </Link>

        {/* Desktop links */}
        <div className="hidden sm:flex items-center gap-1">
          {navLinks.map((item) => (
            <Link
              key={item.link}
              to={item.link}
              onClick={() => window.scrollTo(0, 0)}
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
                isActive(item.link)
                  ? "text-arsen-primary bg-arsen-primary-50 font-semibold"
                  : "text-gray-500 hover:text-arsen-primary hover:bg-arsen-primary-50"
              }`}
            >
              {item.name}
            </Link>
          ))}
          <Link
            to="/events"
            onClick={() => window.scrollTo(0, 0)}
            className="ml-3 px-5 py-2 text-sm font-semibold bg-arsen-primary text-white rounded-lg hover:bg-arsen-primary-600 transition-all duration-200 shadow-sm hover:shadow-md"
          >
            Daftar Sekarang
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="sm:hidden p-2 rounded-lg text-gray-500 hover:bg-gray-100 transition-colors"
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {menuOpen ? (
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile drawer */}
      {menuOpen && (
        <div className="sm:hidden border-t border-gray-100 bg-white px-4 pb-4 pt-2 flex flex-col gap-1 shadow-lg">
          {navLinks.map((item) => (
            <Link
              key={item.link}
              to={item.link}
              onClick={close}
              className={`px-4 py-3 text-sm font-medium rounded-xl transition-colors ${
                isActive(item.link)
                  ? "bg-arsen-primary-50 text-arsen-primary font-semibold"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
            >
              {item.name}
            </Link>
          ))}
          <Link
            to="/events"
            onClick={close}
            className="mt-1 px-4 py-3 text-sm font-semibold bg-arsen-primary text-white rounded-xl text-center hover:bg-arsen-primary-600 transition-colors"
          >
            Daftar Sekarang
          </Link>
        </div>
      )}
    </nav>
  );
}

export default NavigationBar;
